import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Input,
  Label,
  FormGroup,
} from "reactstrap";
import toastr from "toastr";
import { get, post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import ModalConfirm from "../../components/Modal/modalConfirm";
import "./index.scss";

const EMPTY_INFO = { id: null, name: "", phone: "", email: "", isAccountManager: false };
const ROLE_LABEL = { STAFF: "Nhân viên", ADMIN: "Quản trị viên" };
const EMPTY_CREATE = { isOpen: false, name: "", phone: "", email: "", role: "STAFF", password: "" };
const EMPTY_PASSWORD = { id: null, name: "", password: "", confirm: "" };
const EMPTY_TARGET = { id: null, name: "", status: null };

const StaffManager = () => {
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [info, setInfo] = useState(EMPTY_INFO);
  const [create, setCreate] = useState(EMPTY_CREATE);
  const [password, setPassword] = useState(EMPTY_PASSWORD);
  const [changeBlock, setChangeBlock] = useState(EMPTY_TARGET);
  const [deleteTarget, setDeleteTarget] = useState(EMPTY_TARGET);

  const fetchList = () => {
    get("/accounts/staffs")
      .then((res) => setList(res))
      .catch((err) => toastr.error(err?.error || "Không tải được danh sách tài khoản"));
  };

  useEffect(() => {
    fetchList();
  }, []);

  const submit = (url, data, onSuccess) => {
    setIsLoading(true);
    post(url, data)
      .then((res) => {
        onSuccess(res);
        toastr.success("Cập nhật thành công");
      })
      .catch((err) => {
        toastr.error(err?.error || "Có lỗi xảy ra, vui lòng thử lại");
      })
      .finally(() => setIsLoading(false));
  };

  const handleCreate = () => {
    const name = create.name.trim();
    const phone = create.phone.trim();
    const email = create.email.trim();
    if (!name || !phone || !email) {
      toastr.error("Vui lòng nhập đầy đủ thông tin");
      return;
    }
    if (create.password.length < 6) {
      toastr.error("Mật khẩu phải có ít nhất 6 ký tự");
      return;
    }
    submit("/accounts/staffs/create", { name, phone, email, role: create.role, password: create.password }, () => {
      fetchList();
      setCreate(EMPTY_CREATE);
    });
  };

  const handleUpdateInfo = () => {
    const name = info.name.trim();
    const phone = info.phone.trim();
    const email = info.email.trim();
    if (!name || !phone || !email) {
      toastr.error("Vui lòng nhập đầy đủ thông tin");
      return;
    }
    submit("/accounts/staffs/update-info", { userId: info.id, name, phone, email }, (res) => {
      setList(list.map((item) => (item.id === info.id
        ? { ...item, name: res.name, phone: res.phone, email: res.email }
        : item)));
      setInfo(EMPTY_INFO);
    });
  };

  const handleUpdatePassword = () => {
    if (password.password.length < 6) {
      toastr.error("Mật khẩu phải có ít nhất 6 ký tự");
      return;
    }
    if (password.password !== password.confirm) {
      toastr.error("Mật khẩu nhập lại không khớp");
      return;
    }
    submit("/accounts/staffs/update-password", { userId: password.id, password: password.password }, () => {
      setPassword(EMPTY_PASSWORD);
    });
  };

  const handleChangeBlock = () => {
    submit("/accounts/staffs/update-status", { userId: changeBlock.id }, (res) => {
      setList(list.map((item) => (item.id === changeBlock.id ? { ...item, status: res.status } : item)));
      setChangeBlock(EMPTY_TARGET);
    });
  };

  const handleDelete = () => {
    submit("/accounts/staffs/delete", { userId: deleteTarget.id }, () => {
      setList(list.filter((item) => item.id !== deleteTarget.id));
      setDeleteTarget(EMPTY_TARGET);
    });
  };

  return (
    <div className="staff-manager-page">
      <Breadcrumbs title="Tài khoản" breadcrumbItem="Quản lý nhân viên" />
      <div className="staff-manager-page_actions">
        <Button
          color="dark"
          className="btn btn-dark waves-effect waves-light"
          type="button"
          onClick={() => setCreate({ ...EMPTY_CREATE, isOpen: true })}
        >
          Thêm tài khoản
        </Button>
      </div>
      <div className="staff-manager-page_table">
        <table>
          <thead>
            <tr>
              <th>Tên</th>
              <th>Số điện thoại</th>
              <th>Email</th>
              <th>Vai trò</th>
              <th>Trạng thái</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {list.map((item) => (
              <tr key={`staff-manager-${item.id}`}>
                <td>{item.name}</td>
                <td>{item.phone}</td>
                <td>{item.email}</td>
                <td>{ROLE_LABEL[item.role] || item.role}</td>
                <td>
                  <span className={`badge ${item.status === "ACTIVE" ? "bg-success" : "bg-danger"}`}>
                    {item.status === "ACTIVE" ? "Đang hoạt động" : "Đã khoá"}
                  </span>
                </td>
                <td>
                  <Button
                    color="dark"
                    className="btn btn-dark waves-effect waves-light"
                    type="button"
                    onClick={() => setInfo({
                      id: item.id,
                      name: item.name,
                      phone: item.phone,
                      email: item.email,
                      isAccountManager: item.isAccountManager,
                    })}
                  >
                    Sửa thông tin
                  </Button>
                  <Button
                    color="dark"
                    className="btn btn-dark waves-effect waves-light"
                    type="button"
                    onClick={() => setPassword({ ...EMPTY_PASSWORD, id: item.id, name: item.name })}
                  >
                    Đổi mật khẩu
                  </Button>
                  {!item.isAccountManager && (
                    <Button
                      className={`btn ${item.status === "ACTIVE" ? "btn-success" : "btn-danger"} waves-effect waves-light`}
                      type="button"
                      onClick={() => setChangeBlock({ id: item.id, name: item.name, status: item.status })}
                    >
                      {item.status === "ACTIVE" ? "Khóa TK" : "Mở khóa"}
                    </Button>
                  )}
                  {!item.isAccountManager && (
                    <Button
                      className="btn btn-danger waves-effect waves-light"
                      type="button"
                      onClick={() => setDeleteTarget({ id: item.id, name: item.name, status: item.status })}
                    >
                      Xoá TK
                    </Button>
                  )}
                </td>
              </tr>
            ))}
            {list.length === 0 && (
              <tr>
                <td colSpan={6} align="center">Chưa có tài khoản nào</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Modal isOpen={create.isOpen} toggle={() => setCreate(EMPTY_CREATE)} centered={true}>
        <ModalHeader>Thêm tài khoản</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Tên</Label>
            <Input
              value={create.name}
              onChange={(e) => setCreate({ ...create, name: e.target.value })}
            />
          </FormGroup>
          <FormGroup>
            <Label>Số điện thoại (có thể dùng để đăng nhập)</Label>
            <Input
              value={create.phone}
              maxLength={10}
              onChange={(e) => setCreate({ ...create, phone: e.target.value.replace(/\D+/g, "") })}
            />
          </FormGroup>
          <FormGroup>
            <Label>Email (có thể dùng để đăng nhập)</Label>
            <Input
              type="email"
              value={create.email}
              onChange={(e) => setCreate({ ...create, email: e.target.value })}
            />
          </FormGroup>
          <FormGroup>
            <Label>Vai trò</Label>
            <Input
              type="select"
              value={create.role}
              onChange={(e) => setCreate({ ...create, role: e.target.value })}
            >
              <option value="STAFF">{ROLE_LABEL.STAFF}</option>
              <option value="ADMIN">{ROLE_LABEL.ADMIN}</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Mật khẩu</Label>
            <Input
              type="password"
              autoComplete="new-password"
              value={create.password}
              onChange={(e) => setCreate({ ...create, password: e.target.value })}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button disabled={isLoading} className="btn-danger mr-3" onClick={handleCreate}>
            Tạo
          </Button>
          <Button disabled={isLoading} className="btn-secondary mr-3" onClick={() => setCreate(EMPTY_CREATE)}>
            Huỷ
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={info.id !== null} toggle={() => setInfo(EMPTY_INFO)} centered={true}>
        <ModalHeader>Sửa thông tin tài khoản</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Tên</Label>
            <Input
              value={info.name}
              onChange={(e) => setInfo({ ...info, name: e.target.value })}
            />
          </FormGroup>
          <FormGroup>
            <Label>Số điện thoại (có thể dùng để đăng nhập)</Label>
            <Input
              value={info.phone}
              maxLength={10}
              onChange={(e) => setInfo({ ...info, phone: e.target.value.replace(/\D+/g, "") })}
            />
          </FormGroup>
          <FormGroup>
            <Label>Email (có thể dùng để đăng nhập)</Label>
            <Input
              type="email"
              disabled={info.isAccountManager}
              value={info.email}
              onChange={(e) => setInfo({ ...info, email: e.target.value })}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button disabled={isLoading} className="btn-danger mr-3" onClick={handleUpdateInfo}>
            Lưu
          </Button>
          <Button disabled={isLoading} className="btn-secondary mr-3" onClick={() => setInfo(EMPTY_INFO)}>
            Huỷ
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={password.id !== null} toggle={() => setPassword(EMPTY_PASSWORD)} centered={true}>
        <ModalHeader>Đổi mật khẩu - {password.name}</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Mật khẩu mới</Label>
            <Input
              type="password"
              autoComplete="new-password"
              value={password.password}
              onChange={(e) => setPassword({ ...password, password: e.target.value })}
            />
          </FormGroup>
          <FormGroup>
            <Label>Nhập lại mật khẩu mới</Label>
            <Input
              type="password"
              autoComplete="new-password"
              value={password.confirm}
              onChange={(e) => setPassword({ ...password, confirm: e.target.value })}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button disabled={isLoading} className="btn-danger mr-3" onClick={handleUpdatePassword}>
            Lưu
          </Button>
          <Button disabled={isLoading} className="btn-secondary mr-3" onClick={() => setPassword(EMPTY_PASSWORD)}>
            Huỷ
          </Button>
        </ModalFooter>
      </Modal>

      <ModalConfirm
        isOpen={changeBlock.id !== null}
        isLoading={isLoading}
        title={changeBlock.status === "ACTIVE" ? "Khoá tài khoản" : "Mở khoá tài khoản"}
        desc={`Bạn có chắc chắn muốn ${changeBlock.status === "ACTIVE" ? "khoá" : "mở khoá"} tài khoản ${changeBlock.name} không?`}
        handleAccept={handleChangeBlock}
        handleCancel={() => setChangeBlock(EMPTY_TARGET)}
      />
      <ModalConfirm
        isOpen={deleteTarget.id !== null}
        isLoading={isLoading}
        title="Xoá tài khoản"
        desc={`Bạn có chắc chắn muốn xoá tài khoản ${deleteTarget.name} không?`}
        handleAccept={handleDelete}
        handleCancel={() => setDeleteTarget(EMPTY_TARGET)}
      />
    </div>
  );
};

export default StaffManager;
